import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import styles from './UpdateModal.module.css';

export default NiceModal.create(({ appVersion, storeType = 'one' }) => {
  const modal = useModal();
  
  // 앱 종료 브릿지 함수
  const handleCloseApp = () => {
    if (window.BRIDGE && typeof window.BRIDGE.closeWebView === 'function') {
      window.BRIDGE.closeWebView();
    } else if (window.webkit?.messageHandlers?.BRIDGE) {
      window.webkit.messageHandlers.BRIDGE.postMessage({ command: "closeWebView" });
    }
  };
  
  // 스토어로 이동 브릿지 함수
  const handleGoToStore = () => {
    if (storeType === 'one') {
      if (window.BRIDGE && typeof window.BRIDGE.openExternalLink === 'function') {
        // ONE Store 링크 (실제 앱 ID로 대체 필요)
        window.BRIDGE.openExternalLink("onestore://common/product/0000779461");
      }
    } else if (storeType === 'galaxy') {
      if (window.BRIDGE && typeof window.BRIDGE.openExternalLink === 'function') {
        // Galaxy Store 링크 (실제 앱 ID로 대체 필요)
        window.BRIDGE.openExternalLink("samsungapps://ProductDetail/com.puffu.puffupayment");
      }
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>업데이트가 필요합니다</h2>
        </div>
        <div className={styles.modalBody}>
          <p>새로운 버전의 앱이 출시되었습니다.</p>
          <p>원활한 서비스 이용을 위해 최신 버전으로 업데이트해 주세요.</p>
          {appVersion && <p className={styles.versionText}>새 버전: {appVersion}</p>}
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.updateButton} onClick={handleGoToStore}>
            앱 업데이트하기
          </button>
          <button className={styles.closeButton} onClick={handleCloseApp}>
            앱 종료하기
          </button>
        </div>
      </div>
    </div>
  );
});
